import { isSameDay, Locale } from "date-fns";

import { formatDateRangeAbbreviated } from "@/utils";
import { DateRangePreset } from "@components/DatePicker/Range";

// is same day but with support for undefined
const guardedIsSameDay = (d1: Date | undefined, d2: Date | undefined) => {
  if (d1 == undefined || d2 == undefined) {
    return false;
  }
  return isSameDay(d1, d2);
};

export const dateMatchesRange = (
  startDate: Date | undefined,
  endDate: Date | undefined,
  range: DateRangePreset
) => {
  const startDateMatchUndefined =
    startDate == undefined && range.startDate == undefined;

  const endDateMatchUndefined =
    endDate == undefined && range.endDate == undefined;

  // It's a match! Both end/start-date in the range is undefined and so are the dates.
  if (startDateMatchUndefined && endDateMatchUndefined) {
    return true;
  }

  // Finally check the dates.
  const startDateMatch =
    startDateMatchUndefined || guardedIsSameDay(range.startDate, startDate);

  const endDateMatch =
    endDateMatchUndefined || guardedIsSameDay(range.endDate, endDate);

  return startDateMatch && endDateMatch;
};

// Finds a matching date range from a start and end date.
export const reverseDateRange = (
  startDate: Date | undefined,
  endDate: Date | undefined,
  locale: Locale | undefined,
  ranges: DateRangePreset[]
) => {
  const fallback = ranges.find((range) => range.default);
  if (startDate == null && endDate == null) {
    return fallback;
  } else {
    const range = ranges.find((range) =>
      dateMatchesRange(startDate, endDate, range)
    );
    if (range) {
      return range;
    }
  }
  if (!startDate || !endDate) {
    return fallback;
  }
  return {
    label: formatDateRangeAbbreviated(startDate, endDate, locale),
  };
};
